// extracted by mini-css-extract-plugin
export default {"wrapper":"NoDataFound_wrapper__vDQ-o","title":"NoDataFound_title__0c3KE","content":"NoDataFound_content__kg8nf"};